import { render, staticRenderFns } from "./ContactInfoView.vue?vue&type=template&id=2532a303&scoped=true"
import script from "./ContactInfoView.vue?vue&type=script&lang=js"
export * from "./ContactInfoView.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoView.vue?vue&type=style&index=0&id=2532a303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532a303",
  null
  
)

export default component.exports